<div style="text-align: center;" class="avatar-preview">
    <a class="lead-info">
        <img src="{{ userProfileImage }}" width="100" height="100">
    </a>
</div>